module.exports = __webpack_public_path__ + "static/media/calm_slightly-sad.4dfb8efb.svg";